import { NormalizedNumber } from '@sparkdotfi/common-universal'

import { MarketInfo } from '@/features/sparklend/common/data/market-info/marketInfo'

export interface MarketStats {
  totalMarketSizeUSD: NormalizedNumber
  totalValueLockedUSD: NormalizedNumber
  totalBorrowsUSD: NormalizedNumber
}

export function aggregateStats(marketInfo: MarketInfo): MarketStats {
  const aggregatedValues = marketInfo.reserves.reduce(
    (acc, reserve) => {
      acc.totalDebtUSD = acc.totalDebtUSD.plus(reserve.totalDebtUSD)
      acc.totalLiquidityUSD = acc.totalLiquidityUSD.plus(reserve.totalLiquidityUSD)
      return acc
    },
    {
      totalLiquidityUSD: NormalizedNumber.ZERO,
      totalDebtUSD: NormalizedNumber.ZERO,
    },
  )
  const totalValueLockedUSD = aggregatedValues.totalLiquidityUSD.minus(aggregatedValues.totalDebtUSD)

  return {
    totalMarketSizeUSD: aggregatedValues.totalLiquidityUSD,
    totalValueLockedUSD,
    totalBorrowsUSD: aggregatedValues.totalDebtUSD,
  }
}
